export default __webpack_public_path__ + "static/media/2.fd7dd08f.png";